import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const englishIqDemoAdminV1Schema = z.object({
  challenge: z.string().min(1),
  challengeId: z.number().int().positive(),
  clipIds: z.tuple([z.number().int().positive(), z.number().int().positive()]),
  enabled: z.boolean(),
  maximumScore: z.number().int().min(60).max(150).nullable(),
  meaning: z.string().min(1),
  minimumScore: z.number().int().min(60).max(150).nullable(),
  publishedAt: z.number().int().nonnegative().nullable(),
  publishedBy: z.string().nullable(),
});

const getEnglishIqDemoV1DataSchema = z.object({
  demos: z.array(englishIqDemoAdminV1Schema),
});

export type IGetEnglishIqDemoV1Data = z.infer<typeof getEnglishIqDemoV1DataSchema>;

export const getEnglishIqDemoV1ResponseSchema: z.ZodSchema<IAPI<IGetEnglishIqDemoV1Data>> =
  createApiResponseSchema(getEnglishIqDemoV1DataSchema) as z.ZodSchema<
    IAPI<IGetEnglishIqDemoV1Data>
  >;

export type IGetEnglishIqDemoV1Response = IAPI<IGetEnglishIqDemoV1Data>;
